import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBars, faUser } from '@fortawesome/pro-solid-svg-icons';
import { RouterModule } from '@angular/router';
import { MobileMenuService } from '../../shared/services/mobile-menu';
import { AuthStoreService } from '../../core/services/auth-store.service';
import { NotificationBellComponent } from '../../shared/components/notification-bell/notification-bell.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, RouterModule, NotificationBellComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  private mobileMenuService = inject(MobileMenuService);
  protected readonly authStore = inject(AuthStoreService);
  
  faBars = faBars;
  faUser = faUser;

  toggleMenu(): void {
    this.mobileMenuService.toggle();
  }

  protected get userDisplayName(): string {
    const firstName = this.authStore.user()?.first_name ?? '';
    const lastName = this.authStore.user()?.last_name ?? '';
    return `${firstName} ${lastName}`.trim() || 'Mi cuenta';
  }

  protected get userSubtitle(): string {
    const roles = this.authStore.user()?.type ?? [];

    if (roles.includes('SUPERADMIN')) {
      return 'Superadministración';
    }

    if (roles.includes('ADMIN')) {
      return 'Administración';
    }

    if (roles.includes('MANAGER')) {
      return 'Gestión de espacios';
    }

    return 'Ciudadano Activo';
  }

  protected get userInitials(): string {
    return `${this.authStore.user()?.first_name?.[0] || ''}${this.authStore.user()?.last_name?.[0] || ''}`.toUpperCase();
  }

  protected get userProfileRoute(): string {
    const roles = this.authStore.user()?.type ?? [];

    if (roles.includes('SUPERADMIN') || roles.includes('ADMIN') || roles.includes('MANAGER')) {
      return '/admin';
    }
    
    return '/perfil';
  }
}
